import React from 'react'
import i18n from '../../../apps/www/src/locales/en'

const defaultContext: Cinch.Context = {
  footer: i18n.footer,
  navigation: i18n.navigation,
  search: i18n.search,
  authModal: i18n.authModal,
  ourCommitmentModule: i18n.ourCommitmentModule,
  deliveryModule: i18n.deliveryModule,
  footerColumns: [],
}

const GlobalContext = React.createContext<Cinch.Context>(defaultContext)

export default GlobalContext
